import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');

  const formatApiError = (detail) => {
    if (detail == null) return 'Error al iniciar sesión';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
      return detail.map(e => e?.msg || JSON.stringify(e)).filter(Boolean).join(' ');
    }
    if (detail?.msg) return detail.msg;
    return String(detail);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(form.email, form.password);
      toast.success('Bienvenido');
      navigate('/admin');
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || 'Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        backgroundImage: `url('https://images.pexels.com/photos/4253055/pexels-photo-4253055.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="w-full max-w-md">
        <div className="bg-white border-2 border-black shadow-[8px_8px_0_0_#000000] p-8">
          <div className="text-center mb-8">
            <Link to="/" className="font-black text-3xl tracking-tighter">
              ZEIT<span className="text-[#FF3333]">EX</span>
            </Link>
            <p className="text-[#4B5563] mt-2">Panel de Administración</p>
          </div>

          {error && (
            <div className="bg-[#FEE2E2] border-2 border-[#EF4444] text-[#EF4444] px-4 py-3 mb-6">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="font-bold">Email</Label>
              <Input
                id="email"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                className="border-2 border-black rounded-none px-4 py-3 focus:ring-0 focus:border-[#FF3333] focus:shadow-[4px_4px_0_0_#FF3333] transition-all"
                placeholder="admin@sorteos.com"
                data-testid="login-email"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="font-bold">Contraseña</Label>
              <Input
                id="password"
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                className="border-2 border-black rounded-none px-4 py-3 focus:ring-0 focus:border-[#FF3333] focus:shadow-[4px_4px_0_0_#FF3333] transition-all"
                placeholder="••••••••"
                data-testid="login-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#FF3333] text-white font-bold uppercase tracking-wider border-2 border-black px-6 py-3 shadow-[4px_4px_0_0_#000000] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0_0_#000000] active:shadow-none active:translate-y-[4px] active:translate-x-[4px] transition-all disabled:opacity-50"
              data-testid="login-submit"
            >
              {loading ? 'Ingresando...' : 'Ingresar'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/" className="text-sm text-[#4B5563] hover:text-[#FF3333]">
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
